<template lang="pug">
  section#quiz
    .section__content
      .video
        // 測試區
        //- .video__test(style="display: block;")
        //-   div(v-if="isTargetPlayed && currentStep <= allQuizzes")
        //-     p All Quizzes: #[br]{{ allQuizzes }}#[br]#[br]
        //-     p Current Step: #[br]{{ currentStep }}#[br]#[br]
        //-     p Quiz Question: #[br]{{ quizzes[answers.length].question }}#[br]#[br]
        //-     p Youtube ID: #[br]Desktop: {{ quizzes[answers.length].video.main['desktop'] }}#[br]Mobile: {{ quizzes[answers.length].video.main['mobile'] }}
        //-   div(v-else-if="isTargetPlayed && currentStep > allQuizzes")
        //-     p Current Step: #[br]{{ currentStep }}#[br]#[br]
        //-     p Answers {{ answers }}
        //-     p ResultArray {{ resultArray }}
        //-     p Result {{ result }}
        // 影片區
        .video__embed
          .video__frame-main
            youtube#ytplayer(
              ref="mainVideo"
              width="100%"
              height="100%"
              wmode="opaque"
              :video-id="videoId"
              :player-vars="playerVars"
              @ready="onReady"
              @buffering="onBuffering"
              @playing="onPlaying"
              @paused="onPaused"
              @ended="onEnded"
            )
            // isPaused, isStarted
            a.video__play(href="#" @click.prevent="playVideo" v-if="isPaused")  
              span(:class="{'choosing': showOptions, 'pausing': isManualPause}" v-show="isStarted")
            .video__want(v-if="isWantShow")
              .want__text
              a.want__button.want__button-1(href="#" @click.prevent="getResult")
              a.want__button.want__button-2(href="#" @click.prevent="getResult")
            .video__controls
              ul
                li
                  a.controls-replay(href="#" @click.prevent="replay") 重新播放
                li
                  a.controls-play(:class="{'paused': isPaused}" href="#" @click.prevent="playAndPause") 播放/暫停
            a.video__next(href="#" @click.prevent="seeResult" v-if="isEndingVideo")
        // 選項
        .video__options(v-if="isTargetPlayed && currentStep <= allQuizzes")
          p.options__question(:class="`question-${currentStep}`" v-show="showOptions" ref="question")
          ul.options__buttons.buttons(v-show="showOptions" ref="options")
            li(v-for="item, index in quizzes[answers.length].options")
              a.options__button.button(:id="item.id" :class="'options__button--' + item.name" @click="chooseOption(item, index)") {{ item.text }}
      // 下滑提示
      .tips
        .tips__text
          p 下滑了解造局者徵才計畫
        .tips__arrow
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Quiz',
  watch: {
    showOptions() {
      const { options, question } = this.$refs;
      if (this.showOptions) {
        setTimeout(() => {
          options.classList.add('show');
          question.classList.add('show');
        }, 50)
      } else {
        options.classList.remove('show');
        question.classList.remove('show');
      }
    },
    currentPage() {
      this.isWantShow = false;
      this.isEnding = false;
      this.isPaused = true;
      this.isEndingVideo = false;
    }
  },
  props: {
  },
  data: () => {
    return {
      isWantShow: false,
      playbackRate: 1,
      optionsCounter: null,
      isEnding: false,
      isPaused: true,
      isEndingVideo: false,
      queue: [],
      isStarted: false,
      // player: null,
      playerVars: {
        rel: 0,
        controls: 0,
        showinfo: 0,
        modestbranding: 0,
        autoplay: 1,
        playsinline: 1,
        wmode: 'opaque',
      },
      showOptions: false,
      startTime: null,
      pastTime: 0,
      isManualPause: false,
    }
  },
  computed: {
    ...mapState([
      'player',
      'currentPage',
      // 'intro',
      // 'isIntroPlayed',
      'target', 
      'isTargetPlayed', 
      'targetString',
      'answers', 
      'quizzes', 
      'ending', 
      'resultVideo', 
      'resultArray', 
      'result',
      'iosVersion',
      // 'audioPlayer',
    ]),
    allQuizzes() { return this.quizzes.length; },
    currentStep() { return this.answers.length + 1; },
    videoId() {
      const { target, isTargetPlayed, targetString, allQuizzes, currentStep, answers, quizzes, ending, queue } = this;
      let id;
      // if (!isIntroPlayed) {
      //   id = intro;
      // } else
      if (!isTargetPlayed) {
        id = target[targetString];
      } else if (queue[0]) {
        id = queue[0];
      } else if (currentStep <= allQuizzes) {
        id = quizzes[answers.length].video.main['mobile'];
      } else if (currentStep > allQuizzes) {
        id = ending;
      }
      return id;
    },
  },
  methods: {
    ...mapMutations(['setLoading', 'setPlayer', 'setTargetPlayed', 'setPage', 'updateAnswer', 'updateResultArray', 'setResult']),
    // 作答
    chooseOption(option, index) {
      const { quizzes, updateAnswer, updateResultArray, quizDone } = this;

      this.$trackEvent(`question${this.currentStep}`, 'click', `question${this.currentStep}_answer${index + 1}`);

      // 更新作答，可得知完成幾題
      updateAnswer(option.score);

      // 關閉作答選項
      clearTimeout(this.optionsCounter);
      this.optionsCounter = null;
      this.startTime = null;
      this.showOptions = false;
      this.pastTime = 0;

      // 影片佇列第一筆移除（這時的第一筆會是待機影片）
      this.queue.shift();

      // 影片佇列加入選擇答案的影片
      this.queue.push(option.video);

      // 如果不是選 C
      if (option.score !== 'C') updateResultArray([...this.resultArray, option.name]);

      // 如果全部都是 C
      if (this.resultArray.length === 0 && this.currentStep > this.allQuizzes) {
        const array = quizzes.map(item => item.options[2].name);
        updateResultArray(array);
      }

      // 如果作答完成
      if (this.answers.length >= 4) { quizDone(); }
    },
    quizDone() {
      // 完成四題作答後從 resultArray 抽一個結果
      const { resultArray, setResult, resultVideo } = this;
      const random = Math.floor(Math.random() * ((resultArray.length - 1) - 0 + 1)) + 0;
      setResult(resultArray[random]);
      
      // 將結果影片放進佇列
      this.queue.push(resultVideo[this.result])
    },
    getResult() {
      this.queue.shift();
      this.isWantShow = false;
    },
    seeResult() {
      this.setPage('Analysis');
      this.player.pauseVideo();
      if (this.iosVersion >= 15) {
        // this.audioPlayer.play();
      }
    },
    onReady() {
      this.setLoading(false);
      const { player } = this.$refs.mainVideo;
      this.setPlayer(player);
      // this.player = player;
      // 設定播放速率
      this.player.setPlaybackRate(this.playbackRate)

      // window.player = player;

      // 播放影片
      this.player.pauseVideo();
    },
    onBuffering() {
      this.isPaused = true;
    },
    onPlaying() {
      clearTimeout(this.optionsCounter);
      this.optionsCounter = null;
      // this.startTime = null;
      this.isPaused = false;
      this.isManualPause = false;
      if (!this.isStarted) this.isStarted = true;
      if (this.currentStep <= this.allQuizzes) {
        if (this.videoId === this.quizzes[this.currentStep - 1].video.main.mobile) {
          if (this.startTime === null) {
            this.startTime = Date.now();
            // console.log('this.startTime', this.startTime);
          }
          this.optionsCounter = setTimeout(() => {
            this.showOptions = true;
          }, (this.quizzes[this.currentStep - 1].video.main.counter - this.pastTime) / this.playbackRate)
        }
      }
    },
    onPaused() {
      this.isPaused = true;
    },
    onEnded() {
      const { isTargetPlayed, setTargetPlayed, seeResult, currentStep, allQuizzes, queue } = this;
      this.isPaused = true;
      this.startTime = null;
      this.pastTime = 0;

      // 如果播完的影片是 intro 影片
      // if (!isIntroPlayed) {
      //   setIntroPlayed(true);
      //   return;
      // }

      // 如果播完的影片是 目標對象 影片
      if (!isTargetPlayed) {
        setTargetPlayed(true);
        return;
      }

      // 如果播完的影片是作答解析
      if (queue[0] && !this.showOptions) {
        if (
          currentStep > allQuizzes &&
          this.queue.length == 1
        ) {
          this.isEndingVideo = true;
        } else if (
          currentStep > allQuizzes &&
          this.queue.length == 2
        ) {
          this.isWantShow = true;
          return;
        }
        this.queue.shift();
        return;
      }

      // 如果播完的影片是待機影片
      if (queue[0] && this.showOptions) {
        this.player.playVideo();
        return;
      }

      // 如果播完的影片是結尾影片
      if (currentStep > allQuizzes) {
        // this.isEnding = true;
        seeResult();
        return;
      }

      // 問題影片播完時顯示選項
      // this.showOptions = true;

      // 問題影片播完時將待機影片加入佇列
      this.queue.push(this.quizzes[this.answers.length].video.idle['mobile']);
    },
    playVideo() {
      const { player } = this;
      if (player === null) return;
      player.playVideo();
    },
    replay() {
      this.player.seekTo(0);
      this.player.playVideo();
      this.pastTime = 0;
      this.startTime = null;
      if (this.queue.length === 0) this.showOptions = false;
    },
    playAndPause() {
      const { isPaused } = this;

      if (this.startTime == null || this.showOptions == true) {
        if (isPaused) {
          this.player.playVideo();
          this.isManualPause = false;
        } else {
          this.player.pauseVideo();
          this.isManualPause = true;
        }
        return;
      }

      if (isPaused) {
        this.player.playVideo();
        this.isManualPause = false;
        this.startTime = Date.now();
        // console.log('this.startTime', this.startTime);
        this.optionsCounter = setTimeout(() => {
          this.showOptions = true;
        }, (this.quizzes[this.currentStep - 1].video.main.counter - this.pastTime) / this.playbackRate)
      } else {
        this.player.pauseVideo();
        this.isManualPause = true;
        const currentTime = Date.now();
        // this.optionsCounter = null;
        clearTimeout(this.optionsCounter);
        // console.log('startTime' ,this.startTime);
        // console.log('currentTime', currentTime);
        // console.log('currentTime - startTime', currentTime - this.startTime);
        this.pastTime += currentTime - this.startTime;
        // console.log('pastTime', this.pastTime);
      }
    },
  },
  mounted() {
    // this.isEnding = false;
  },
  components: {
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/quiz/';

#quiz {

  position: relative;
  padding-top: vwXL(98);
  margin-bottom: vwXL(200);

  background: url($assets + 'background.png') center top no-repeat;
  background-size: 100% auto;

  z-index: 3;

  --video-height: calc(var(--default-vh, 1vh) * 100 - 111px);
  @include tablet {
    --video-height: calc(var(--default-vh, 1vh) * 100 - #{vw(111)});
    padding-top: 0;
    margin-bottom: 0;
    background: none;
  }
  @at-root #main #quiz {
    // @include tablet {
    min-height: 0;
    // }
  }

  .video {
    position: relative;
    width: vwXL(1212);
    height: vwXL(689);
    margin: 0 auto;
    border: #07aa6d vwXL(8) solid;
    // border-top: 0;
    border-radius: vwXL(6);
    

    // height: vh(683);
    // height: 100vh;
    // height: var(--video-height);
    // max-height: (680 * 2) + px;
    @include tablet {
      width: auto;
      height: var(--video-height);
      max-height: vw(680 * 2);
      border: none;
    }
    &__embed {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      z-index: 1;
      > div {
        position: absolute;
        top: 50%;
        left: 50%;
        // width: 100%;
        width: vwXL(1212 - 16);
        // max-width: (1209 * 2) + px;
        // height: 100%;
        height: vwXL(889);
        // max-height: (680 * 2) + px;
        transform: translate(-50%, -50%);
        @include tablet {
          top: 0;
          width: calc(var(--video-height) * 1.779);
          height: 100%;
          max-width: vw(1209 * 2);
          max-height: vw(680 * 2);
          transform: translateX(-50%);
        }
      }
      iframe {
        // opacity: 0.5;
        pointer-events: none;
      }
    }
    &__play {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      // border-radius: 100px;
      // transform: translate(-50%, -50%);
      // background: rgba(#277741, 0.5);
      @include tablet {
        // width: vw(100);
        // height: vw(100);
        // border-radius: vw(100);
      }
      // &::before {
      //   content: '';
      //   position: absolute;
      //   top: 50%;
      //   left: 50%;
      //   width: 0;
      //   height: 0;
      //   border-style: solid;
      //   border-width: 20px 0 20px 34.6px;
      //   border-color: transparent transparent transparent #ffffff;
      //   transform: translate(-36%, -50%);
      //   @include tablet {
      //     border-width: vw(20) 0 vw(20) vw(34.6);
      //   }
      // }
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        width: vwXL(200);
        height: vwXL(200);
        border-radius: 100%;
        background-image: url($assets + 'loading.png');
        background-color: #00541e;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: contain;
        transform: translate(-50%, -50%);
        &.choosing { background-image: url($assets + 'loading-choosing.png'); }
        &.pausing {opacity: 0;}
        @include tablet {
          width: vw(300);
          height: vw(300);
        }

        &::before,
        &::after {
          content: '';
          position: absolute;
          top: vwXL(20);
          left: vwXL(128);
          width: vwXL(7);
          height: vwXL(24);
          background: #00541e;
          animation: dot 2s linear infinite;
          @include tablet {
            top: vw(34);
            left: vw(193);
            width: vw(10);
            height: vw(30);
          }
        }
        &::after {
          left: vwXL(136);
          animation: dot2 2s linear infinite;
          @include tablet {
            left: vw(204);
          }
        }
      }
    }
    @keyframes dot {
      0% {
        opacity: 1;
      }
      24% {
        opacity: 1;
      }
      25% {
        opacity: 0;
      }
      100% {
        opacity: 0;
      }
    }
    @keyframes dot2 {
      0% {
        opacity: 1;
      }
      49% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
      100% {
        opacity: 0;
      }
    }
    &__next {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      // background: rgba(red, 0.5);
    }
    &__options {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 2;
    }
    &__test {
      position: absolute;
      top: 0;
      left: 0;
      font-size: 28px;
      font-weight: 500;
      line-height: 1.5;
      padding: 110px 50px 50px;
      z-index: 2;
      pointer-events: none;
      @include tablet {
        font-size: vw(28);
        padding: vw(110) vw(50) vw(50);
      }
    }
  }

  .video__want {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url($assets + 'want-background_desktop.png');
    background-color: rgba(0,0,0,0.7);
    background-position: center top;
    background-size: 100% 100%;
    z-index: 3;
    @include tablet {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background-image: url($assets + 'want-background.png');
      background-size: vw(750) auto;
    }
  }

  .video__controls {
    position: absolute;
    top: vwXL(110);
    right: 0;
    // width: 100%;
    // height: 100%;
    z-index: 2;
    @include tablet {
      top: 0;
      right: auto;
      left: 50%;
      width: vw(750);
      height: 0;
      transform: translateX(-50%);
    }
    ul {
      display: flex;
      padding-top: vwXL(25);
      padding-right: vwXL(25);
      @include tablet {
        position: absolute;
        top: 0;
        right: 0;
        flex-direction: column;
        width: vw(60);
        padding-top: vw(30);
        padding-right: vw(15);
        box-sizing: content-box;
      }
    }
    li {
      margin-left: vwXL(17);
      @include tablet {
        margin-bottom: vw(45);
        margin-left: 0;
      }
    }
    a {
      position: relative;
      display: block;
      width: vwXL(30);
      height: vwXL(30);
      font-size: 0;
      text-indent: -5000px;
      background-image: url($assets + 'controls_desktop.png');
      background-size: vwXL(90) vwXL(30);
      @include tablet {
        width: vw(60);
        height: vw(60);
        background-image: url($assets + 'controls.png');
        background-size: vw(186) vw(62);
      }
    }
    a::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 150%;
      height: 150%;
      // background: rgba(0,0,0,0.7);
      transform: translate(-50%, -50%);
    }
    .controls-replay {
      background-position: 0 0;
    }
    .controls-play {
      background-position: vwXL(-30) 0;
      @include tablet {
        background-position: vw(-62) 0;
      }
      &.paused {
        background-position: vwXL(-60) 0;
        @include tablet {
          background-position: vw(-124) 0;
        }
      }
    }
  }

  .want__text {
    position: absolute;
    left: 50%;

    top: vwXL(265);
    width: vwXL(483);
    height: vwXL(219);
    background-image: url($assets + 'want-text_desktop.png');

    background-size: contain;
    background-repeat: no-repeat;
    background-position: 0 0;
    transform: translateX(-50%);
    @include tablet {
      position: static;
      top: vw(386);
      width: vw(498);
      height: vw(226);
      margin-top: vw(74);
      background-image: url($assets + 'want-text.png');
      transform: none;
    }
  }
  
  .want__button {
    position: absolute;
    left: 50%;

    width: vwXL(220);
    height: vwXL(79);
    background-image: url($assets + 'want-button_desktop.png');
    background-size: vwXL(220) vwXL(160);

    @include tablet {
      position: static;
      width: vw(304);
      height: vw(108);
      margin-top: vw(44);
      background-image: url($assets + 'want-button.png');
      background-size: vw(304) vw(220);
    }
    &-1 {
      top: vwXL(540);
      transform: translateX(vwXL(-236));
      @include tablet {
        top: vw(657);
        background-position: 0 0;
        transform: none;
      }
    }
    &-2 {
      top: vwXL(540);
      background-position: 0 vwXL(-80);
      transform: translateX(vwXL(17));
      @include tablet {
        top: vw(810);
        background-position: 0 vw(-110);
        transform: none;
      }
    }
  }

  .options__question {
    height: vwXL(27);
    margin-bottom: vwXL(13);
    background-image: url($assets + 'options-question_desktop.png');
    background-size: vwXL(364) vwXL(112);
    background-repeat: no-repeat;
    opacity: 0;
    transform: translateY(50%);
    transition: .5s ease;
    transition-property: opacity, transform;
    @include tablet {
      height: vw(40);
      margin-bottom: vw(15);
      background-image: url($assets + 'options-question.png');
      background-size: vw(573) vw(176);
    }
    &.show {
      opacity: 1;
      transform: translateY(0%);
    }
    &.question-1 { background-position: center 0; }
    &.question-2 { background-position: center vwXL(-28); }
    &.question-3 { background-position: center vwXL(-56); }
    &.question-4 { background-position: center vwXL(-84); }
    @include tablet {
      &.question-1 { background-position: center 0; }
      &.question-2 { background-position: center vw(-44); }
      &.question-3 { background-position: center vw(-88); }
      &.question-4 { background-position: center vw(-132); }
    }
  }

  .options__buttons {
    display: flex;
    justify-content: center;
    padding-bottom: vwXL(26);
    overflow: hidden;
    @include tablet {
      padding-bottom: vw(26);
    }
    li {
      margin: 0 vwXL(52.5);
      opacity: 0;
      transform: translateY(50%);
      transition: .5s ease;
      transition-property: opacity, transform;
      @include tablet {
        margin: 0 vw(11.5);
      }
      &:nth-child(1) { transition-delay: .1s; }
      &:nth-child(2) { transition-delay: .2s; }
      &:nth-child(3) { transition-delay: .3s; }
    }
    &.show li {
      opacity: 1;
      transform: translateY(0%);
    }
  }

  .options__button {
    position: relative;
    width: vwXL(185);
    height: vwXL(76);
    font-size: 0;
    text-indent: -5000px;
    white-space: pre-wrap;
    background-image: url($assets + 'options-button_desktop.png');
    background-repeat: no-repeat;
    background-size: vwXL(765) vwXL(314);
    z-index: 2;
    cursor: pointer; 

    &--q1-a { background-position: 0 0; }
    &--q1-b { background-position: vwXL(-290) 0; }
    &--q1-c { background-position: vwXL(-580) 0; }

    &--q2-a { background-position: 0 vwXL(-78); }
    &--q2-b { background-position: vwXL(-290) vwXL(-78); }
    &--q2-c { background-position: vwXL(-580) vwXL(-78); }

    &--q3-a { background-position: 0 vwXL(-157); }
    &--q3-b { background-position: vwXL(-290) vwXL(-157); }
    &--q3-c { background-position: vwXL(-580) vwXL(-157); }

    &--q4-a { background-position: 0 vwXL(-236); }
    &--q4-b { background-position: vwXL(-290) vwXL(-236); }
    &--q4-c { background-position: vwXL(-580) vwXL(-236); }

    @include tablet {
      width: vw(203);
      height: vw(95);
      text-indent: vw(-5000);
      background-image: url($assets + 'options-button.png');
      background-size: vw(665) vw(400);

      &--q1-a { background-position: 0 0; }
      &--q1-b { background-position: vw(-231) 0; }
      &--q1-c { background-position: vw(-462) 0; }

      &--q2-a { background-position: 0 vw(-100); }
      &--q2-b { background-position: vw(-231) vw(-100); }
      &--q2-c { background-position: vw(-462) vw(-100); }

      &--q3-a { background-position: 0 vw(-200); }
      &--q3-b { background-position: vw(-231) vw(-200); }
      &--q3-c { background-position: vw(-462) vw(-200); }

      &--q4-a { background-position: 0 vw(-300); }
      &--q4-b { background-position: vw(-231) vw(-300); }
      &--q4-c { background-position: vw(-462) vw(-300); }
    }

  }

  // .tips {
  //   &::after {
  //     content: '';
  //     width: vwXL(46);
  //     height: vwXL(20);
  //     margin-top: vwXL(13);
  //     background: url($assets + 'tips-arrow.png') 0 0 no-repeat;
  //     background-size: vwXL(46) vwXL(20);
  //   }
  // }

  .tips {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    position: absolute;
    bottom: vwXL(11);
    right: vwXL(50);
    // height: 111px;

    @include tablet {
      position: static;
      height: vw(111);
    }

    &__text {
      color: #77b79e;
      font-size: vwXL(30);
      letter-spacing: vwXL(PsdLetterSpacing(240, 30));
      writing-mode: vertical-lr;
      @include tablet {
        color: #008536;
        font-size: vw(30);
        text-indent: vw(PsdLetterSpacing(240, 30));
        letter-spacing: vw(PsdLetterSpacing(240, 30));
        writing-mode: initial;
      }
    }
    &__arrow {
      width: vwXL(46);
      height: vwXL(20);
      margin-top: vwXL(13);
      background: url($assets + 'tips-arrow_desktop.png') 0 0 no-repeat;
      background-size: contain;
      animation: 2s tipsArrow ease-in-out infinite;
      @include tablet {
        width: vw(62);
        height: vw(27);
        margin-top: vw(15);
        background: url($assets + 'tips-arrow.png') 0 0 no-repeat;
        background-size: contain;
      }
    }
    @keyframes tipsArrow {
      0%, 100% {
        transform: translateY(-10%);
      }
      50% {
        transform: translateY(30%);
      }
    }
  }

}

</style>
